import React, { Component } from 'react';
import { Tree } from 'primereact/tree';


class TreeDiagram extends Component {
    constructor(props) {
        super(props);
        this.state = { pastruct: null };
    }

    componentDidMount() {
        this.setState({
            pastruct: JSON.parse(this.props.pastruct),
        });
    }

    render() {
        return (
            <div>
                <Tree value={this.state.pastruct} layout={'horizontal'} />
            </div>
        );
    }
}

export default TreeDiagram;




// WEBPACK FOOTER //
// ./src/components/TreeDiagram.js